export const color = {
  prim: '#61dafb',
  sec: '#000000',
  tri: '#282c34',
}

export const font = {
  title: 'Quicksand',
}

export const boxShadow = {
  outset: '2px 2px 2px rgba(0, 0, 0,.2), -2px -2px 2px rgba(255, 255, 255, .5)',
  inset: 'inset 2px 2px 2px rgba(0, 0, 0, .2), inset -2px -2px 2px rgba(255, 255, 255, .5)',
}
